import Header from "../componentes/header/header";
import Footer from "../componentes/footer/footer";
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './conserto_relogio.css';
import { assets } from "../assets/assets";
import { abrirOrcamentoWhats, trazerRodapePaginasProdutos, trazerTituloProdutos } from "../utils/utils";

const Pilhas = () => {

  const navigate = useNavigate();
  useEffect(() => {
    document.title = "Trinco | Pilhas";
  }, []);

  return (
    <div className="servico-detalhe-page">
      <Header />
      {/* Hero Banner */}
      <section className="servico-hero" style={{ backgroundImage: `url(${assets.headerPilhas})` }}>
        <div className="servico-hero-overlay">
          <h1>Pilhas</h1>
          {/* <p>Para quem procura por pilhas</p>*/}
        </div>
      </section>

      {/* Conteúdo Explicativo */}
      <main className="conteudo-servico-container">

        <article className="bloco-texto">
          <h2>{trazerTituloProdutos()}</h2>
        </article>

        {/* Aqui começa todo o conteudo */}
        {/* Seção de Grade de Produtos - Baterias e Pilhas */}
        <section className="acessorios-grid">

          <div className="acessorio-card">
            <div className="acessorio-ilustracao"><img src={assets.pilhasRelogio} alt="" /></div>
            <h3>Relógios</h3>
            <p>Para relógios de pulso, relógios de parede e despertadores.</p>
          </div>

          <div className="acessorio-card">
            <div className="acessorio-ilustracao"><img src={assets.pilhasControle} alt="" /></div>
            <h3>Aparelhos</h3>
            <p>Para controles remotos, brinquedos, balanças e dispositivos eletrônicos.</p>
          </div>

          <div className="acessorio-card">
            <div className="acessorio-ilustracao"><img src={assets.pilhasAuditivo} alt="" /></div>
            <h3>Auditiva</h3>
            <p>Para aparelhos auditivos.</p>
          </div>

        </section>

        {/* Aqui termina todo o conteudo */}

        <div className="fechamento-texto">
          <h4>{trazerRodapePaginasProdutos('pilhas')}</h4>
        </div>

        {/* CTA FINAL */}
        <div className="cta-container-detalhe">
          <button className="btn-orcamento-whats" onClick={() => abrirOrcamentoWhats('pilhas')}>
            Solicitar disponibilidade
          </button>
          <button className="btn-voltar-simples" onClick={() => navigate('/')}>
            Voltar para o início
          </button>
        </div>

      </main>
      <Footer />
    </div>
  )
}

export default Pilhas;